import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { getBlogCategoriesNotPaginated } from '../api/blog';

const initialState = {
  categories: [],
  isLoading: false,
  error: null,
};

export const useBlogCategoriesStore = create(
  persist(
    (set, get) => ({
      ...initialState,

      // Acciones síncronas
      setBlogCategories: (categories) => set({ 
        categories, 
        isLoading: false, 
        error: null 
      }),
      
      setBlogCategoriesLoading: (isLoading) => set({ isLoading }),
      
      setBlogCategoriesError: (error) => set({ 
        error, 
        isLoading: false 
      }),
      
      clearBlogCategories: () => set({ 
        categories: [], 
        isLoading: false, 
        error: null 
      }),
      
      loadBlogCategories: (categories) => set({ 
        categories: categories || [], 
        isLoading: false, 
        error: null 
      }),

      // Acción asíncrona
      fetchBlogCategories: async () => {
        set({ isLoading: true, error: null });
        try {
          const { data, status } = await getBlogCategoriesNotPaginated({ with_post: true });
          if (status === 200) {
            set({ 
              categories: data, 
              isLoading: false, 
              error: null 
            });
          } else {
            throw new Error('Error loading blog categories');
          }
        } catch (error) {
          set({ 
            isLoading: false, 
            error: error.message 
          });
        }
      }
    }),
    {
      name: 'blog-categories-storage',
      partialize: (state) => ({
        categories: state.categories
      })
    }
  )
);
